export default __webpack_public_path__ + "static/media/ImpactTestingImg.a7d84c7d.jpg";